// extracted by mini-css-extract-plugin
export default {"info_list":"IpInfo_info_list__7ypYY","info_li":"IpInfo_info_li__3DBSj","item_title":"IpInfo_item_title__l2V0z","item_value":"IpInfo_item_value__RyWyZ"};